/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FilterModel, IFilterComponentProps, IFilterProto } from '@monorepo/controlled/src/models/filter.model';
import { observer } from 'mobx-react';
import { FilterBooleanMenu } from '@monorepo/base/src/components/filters/filter-boolean-menu/filter-boolean-menu';
import { NumberActions } from '@monorepo/tools/src/lib/utils/number';

interface IBooleanFilterProto {
	cellKey: string;
	columnName: string;
	value: boolean;
	entity?: string;
}

interface IBooleanFilterComponentProps extends IFilterComponentProps {
	cellKey: string;
	columnName: string;
	value: boolean;
	entity?: string;
}

const BooleanFilter = (props: IBooleanFilterComponentProps) => {
	const { filter, onCancel, onApply, addFilter, editFilter, columnName, cellKey, entity, value } = props;
	const protoObj = BooleanFilterPrototype({ columnName, cellKey, value, entity });

	const onAddBooleanFilter = (action: NumberActions.Equals, _value: boolean) => {
		const booleanFilter = new FilterModel({
			label: `${columnName} to ${typeof _value === 'string' ? Boolean(_value) : _value}`,
			action,
			value: _value,
			prototype: protoObj,
		});

		if (filter?.index && editFilter) {
			editFilter(filter.index, booleanFilter);
		} else {
			addFilter(booleanFilter);
		}

		onApply();
	};

	// const getDefaultValue = () => {
	// 	if (filter?.value) {
	// 		if (typeof filter?.value === 'string') {
	// 			return filter?.value.split(',');
	// 		}

	// 		if (Array.isArray(filter?.value)) {
	// 			return filter?.value;
	// 		}
	// 	}

	// 	return [];
	// };

	return (
		<FilterBooleanMenu
			title={columnName}
			defaultValue={true}
			// defaultAction={filter?.action}
			onApply={onAddBooleanFilter}
			onCancel={onCancel}
		/>
	);
};

export const BooleanFilterPrototype = (props: IBooleanFilterProto): IFilterProto => {
	const { columnName, cellKey, entity, value } = props;

	return {
		MenuComponent: columnName,
		FilterComponent: observer((props: IFilterComponentProps) =>
			BooleanFilter({
				...props,
				columnName,
				cellKey,
				value,
			})
		),
		prop: `${entity}${cellKey}`,
		multi: false,
		deletable: true,
		filterFunc<T>(models: T[], filter: FilterModel): T[] {
			const { value } = filter;

			const normalizeBoolean = (v: unknown): boolean | null => {
				if (v === true || v === 'true') {
					return true;
				}
				if (v === false || v === 'false') {
					return false;
				}
				return null;
			};

			const filterValue = normalizeBoolean(value);
			if (filterValue === null) {
				return [];
			}

			return models.filter(model => {
				const fieldValue = (model as Record<string, unknown>)[cellKey];
				const normalizedField = normalizeBoolean(fieldValue);

				if (normalizedField === null) {
					return false;
				}

				return normalizedField === filterValue;
			});
		},
	};
};
